// Getting Started
import Vue from 'vue'
import Form from './index.vue'

const cloudEmailForm = new Vue({
    render: h => h(Form),
}).$mount('#cloud-email-form');